/**
 * Contact.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';
import EditablePage from './EditablePage';
import SEO from './SEO';
import { useLanguage } from '../context/LanguageContext';
import { getTranslatedPage } from '../i18n/pages';

export default function Contact() {
  const { language } = useLanguage();
  const tr = getTranslatedPage('contact', language);
  // Structured data for ContactPage
  const contactPageSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Cranford Publications",
    "description": "Contact information for Cranford Publications - Celtic Fiddle Music Shop",
    "url": "https://www.cranfordpub.ca/contact",
    "mainEntity": {
      "@type": "Organization",
      "@id": "https://www.cranfordpub.ca/#organization",
      "name": "Cranford Publications",
      "url": "https://www.cranfordpub.ca/",
      "logo": "https://www.cranfordpub.ca/images/collage9.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+1-902-929-2391",
          "contactType": "customer service",
          "availableLanguage": ["English"],
          "areaServed": ["CA", "US"],
          "hoursAvailable": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "opens": "09:00",
            "closes": "18:00"
          }
        },
        {
          "@type": "ContactPoint",
          "telephone": "+1-902-929-2391",
          "contactType": "customer service",
          "availableLanguage": ["English"],
          "areaServed": ["WorldWide"]
        }
      ],
      "email": "cranfordpub@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Nova Scotia",
        "addressCountry": "CA"
      }
    }
  };

  return (
    <>
      <SEO 
        title={`${tr?.title || 'Contact Cranford Publications'} | Get in Touch`}
        description={tr?.description || 'Contact Cranford Publications for inquiries about Celtic fiddle music books and CDs. Phone: 1-902-929-2391 . Located in Cape Breton Island, Nova Scotia, Canada.'}
        canonical="/contact"
        keywords="contact Cranford Publications, Celtic music shop contact, buy fiddle music, Cape Breton music store"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(contactPageSchema)}
        </script>
      </Helmet>
      <EditablePage pageId="contact" pageTitle={tr?.title || 'Contact Us'} />
    </>
  );
} 